export enum InvitationAcceptUiStateType {
  Success = 'success',
  AlreadyAccepted = 'alreadyAccepted',
  WrongAccount = 'wrongAccount',
  EmailUnverified = 'emailUnverified',
  LinkTerminal = 'linkTerminal',
  Unknown = 'unknown',
}

import type { InvitationOperationResult } from '@modules/memberships/memberships.type'

export type { InvitationOperationResult }

export enum InvitationOperationCategory {
  AcceptSuccess = 'acceptSuccess',
  SendSuccess = 'sendSuccess',
  SendInformational = 'sendInformational',
  SendConflict = 'sendConflict',
  IdentityMismatch = 'identityMismatch',
  EmailBlocked = 'emailBlocked',
  LinkTerminal = 'linkTerminal',
  Unknown = 'unknown',
}

export type InvitationAcceptUiState =
  | { type: InvitationAcceptUiStateType.Success; result: InvitationOperationResult }
  | { type: InvitationAcceptUiStateType.AlreadyAccepted; result: InvitationOperationResult }
  | { type: InvitationAcceptUiStateType.WrongAccount; message: string }
  | { type: InvitationAcceptUiStateType.EmailUnverified; message: string }
  | { type: InvitationAcceptUiStateType.LinkTerminal; message: string; outcome: string }
  | { type: InvitationAcceptUiStateType.Unknown; message: string }
